const state = {
  google: {
    initialized: false,
  },
};

export type SocialLoginState = typeof state;

export default state;
